var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn",
      style: _vm.buttonStyle,
      attrs: { type: "button", disabled: _vm.disabled || _vm.isLoading },
      on: { click: _vm.onClick },
    },
    [
      _vm.isLoading
        ? _c("strong", [_vm._v("Adicionando ao carrinho...")])
        : _c("strong", { key: _vm.label }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }